module.exports = __webpack_public_path__ + "static/img/M17S.9cbf6cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/M17S.png
// module id = 70
// module chunks = 1